<template>
  <div
    v-if="props.item"
    class="relative overflow-visible rounded-md pt-4 pb-2 px-4 mb-4 last:mb-0 bg-idle-white"
    :data-testid="props.dataTestid + '-buy-now-items-container'"
  >
    <TsTagTrolleyChannel
      :data-testid="props.dataTestid + '-buy-now-channel-tag'"
      :label="channelTagLabel"
      variant="success"
    />
    <TsMedia
      :data-testid="props.dataTestid + '-buy-now-item-card'"
      appendClass="items-center border-b last:border-b-0 max-md:block py-4 last:pb-2"
    >
      <TsTrolleyCardCheckout
        v-if="detailedItem"
        :product="detailedItem.product"
        :data-testid="props.dataTestid + '-buy-now'"
        :quantity="detailedItem.quantity"
      />
    </TsMedia>
  </div>
</template>

<script lang="ts" setup>
import { ProductService } from "~/services/product.service";
import type { Product } from "~/types/ecom/product/product.type";
import { TrolleyChannel } from "~/types/ecom/trolley/trolley-map";


const TsTagTrolleyChannel = defineAsyncComponent(
    () => import('~/components/atoms/TsTagTrolleyChannel.vue')
);

const TsTrolleyCardCheckout = defineAsyncComponent(
    () => import('~/components/organisms/TsTrolleyCardCheckout.vue')
);


type TrolleyItem = { 
  product_code: Product["code"];
  quantity: number;
  channel: TrolleyChannel;
};

type Props = {
  item?: TrolleyItem;
  dataTestid: string;
};

const props = withDefaults(defineProps<Props>(), {});

const channelTagLabel = computed(() => {
  switch (props.item?.channel) {
    case TrolleyChannel.Delivery:
      return "Delivery";
    case TrolleyChannel.Collection:
      return "Click & Collect";
    case TrolleyChannel.Directship:
      return "Direct From Supplier";
    case TrolleyChannel.NextDayCollection:
      return "Collect Next Day";
  }
});

const detailedItem = ref<any>(null);

onMounted(async () => {
  if (!props.item || !props.item.product_code) return;
  try{
  const productService = new ProductService();
  const [productData] = await productService.getProducts([
    Number(props.item.product_code),
  ]);
  detailedItem.value = {
    product: productData,
    quantity: props.item.quantity,
    channel: props.item.channel,
  };
}catch(e){
  const { $customClientErrorHandler } = useNuxtApp();
    let errorMeta = {item: props.item, }

    $customClientErrorHandler(
    e,
    'high',
    'Product Store Page Error - trying to fetch getproduct',
    errorMeta);
    return e;
    }

});
</script>
